/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * Catch Backend
 * Catch Backend API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  DtoEnvelopePatientServiceCenter,
  GetLabOrdersV0LabsOrdersGetParams,
  HTTPValidationError,
  LabOrderDetail,
  LabOrderRequest,
  LabOrderResponseV0,
  LabOrdersListResponse,
  PatientDetailsRequest,
  PatientDetailsResponse,
  SearchPatientServiceCentersV0LabsPatientServiceCentersGetParams
} from '.././model';

import { customCatchBackendFetcher } from '../../../client/customFetcher';




/**
 * @summary Update Patient Details
 */
export const updatePatientDetailsV0LabsPatientDetailsPut = (
    patientDetailsRequest: PatientDetailsRequest,
 ) => {
      
      
      return customCatchBackendFetcher<PatientDetailsResponse>(
      {url: `/v0/labs/patient-details`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: patientDetailsRequest
    },
      );
    }
  


export const getUpdatePatientDetailsV0LabsPatientDetailsPutMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePatientDetailsV0LabsPatientDetailsPut>>, TError,{data: PatientDetailsRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updatePatientDetailsV0LabsPatientDetailsPut>>, TError,{data: PatientDetailsRequest}, TContext> => {

const mutationKey = ['updatePatientDetailsV0LabsPatientDetailsPut'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePatientDetailsV0LabsPatientDetailsPut>>, {data: PatientDetailsRequest}> = (props) => {
          const {data} = props ?? {};

          return  updatePatientDetailsV0LabsPatientDetailsPut(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdatePatientDetailsV0LabsPatientDetailsPutMutationResult = NonNullable<Awaited<ReturnType<typeof updatePatientDetailsV0LabsPatientDetailsPut>>>
    export type UpdatePatientDetailsV0LabsPatientDetailsPutMutationBody = PatientDetailsRequest
    export type UpdatePatientDetailsV0LabsPatientDetailsPutMutationError = HTTPValidationError

    /**
 * @summary Update Patient Details
 */
export const useUpdatePatientDetailsV0LabsPatientDetailsPut = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePatientDetailsV0LabsPatientDetailsPut>>, TError,{data: PatientDetailsRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updatePatientDetailsV0LabsPatientDetailsPut>>,
        TError,
        {data: PatientDetailsRequest},
        TContext
      > => {

      const mutationOptions = getUpdatePatientDetailsV0LabsPatientDetailsPutMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * @summary Search Patient Service Centers
 */
export const searchPatientServiceCentersV0LabsPatientServiceCentersGet = (
    params: SearchPatientServiceCentersV0LabsPatientServiceCentersGetParams,
 signal?: AbortSignal
) => {
      
      
      return customCatchBackendFetcher<DtoEnvelopePatientServiceCenter>(
      {url: `/v0/labs/patient-service-centers`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getSearchPatientServiceCentersV0LabsPatientServiceCentersGetQueryKey = (params?: SearchPatientServiceCentersV0LabsPatientServiceCentersGetParams,) => {
    return [`/v0/labs/patient-service-centers`, ...(params ? [params]: [])] as const;
    }

    
export const getSearchPatientServiceCentersV0LabsPatientServiceCentersGetQueryOptions = <TData = Awaited<ReturnType<typeof searchPatientServiceCentersV0LabsPatientServiceCentersGet>>, TError = HTTPValidationError>(params: SearchPatientServiceCentersV0LabsPatientServiceCentersGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchPatientServiceCentersV0LabsPatientServiceCentersGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchPatientServiceCentersV0LabsPatientServiceCentersGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchPatientServiceCentersV0LabsPatientServiceCentersGet>>> = ({ signal }) => searchPatientServiceCentersV0LabsPatientServiceCentersGet(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchPatientServiceCentersV0LabsPatientServiceCentersGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type SearchPatientServiceCentersV0LabsPatientServiceCentersGetQueryResult = NonNullable<Awaited<ReturnType<typeof searchPatientServiceCentersV0LabsPatientServiceCentersGet>>>
export type SearchPatientServiceCentersV0LabsPatientServiceCentersGetQueryError = HTTPValidationError


export function useSearchPatientServiceCentersV0LabsPatientServiceCentersGet<TData = Awaited<ReturnType<typeof searchPatientServiceCentersV0LabsPatientServiceCentersGet>>, TError = HTTPValidationError>(
 params: SearchPatientServiceCentersV0LabsPatientServiceCentersGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchPatientServiceCentersV0LabsPatientServiceCentersGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchPatientServiceCentersV0LabsPatientServiceCentersGet>>,
          TError,
          Awaited<ReturnType<typeof searchPatientServiceCentersV0LabsPatientServiceCentersGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useSearchPatientServiceCentersV0LabsPatientServiceCentersGet<TData = Awaited<ReturnType<typeof searchPatientServiceCentersV0LabsPatientServiceCentersGet>>, TError = HTTPValidationError>(
 params: SearchPatientServiceCentersV0LabsPatientServiceCentersGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchPatientServiceCentersV0LabsPatientServiceCentersGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchPatientServiceCentersV0LabsPatientServiceCentersGet>>,
          TError,
          Awaited<ReturnType<typeof searchPatientServiceCentersV0LabsPatientServiceCentersGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useSearchPatientServiceCentersV0LabsPatientServiceCentersGet<TData = Awaited<ReturnType<typeof searchPatientServiceCentersV0LabsPatientServiceCentersGet>>, TError = HTTPValidationError>(
 params: SearchPatientServiceCentersV0LabsPatientServiceCentersGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchPatientServiceCentersV0LabsPatientServiceCentersGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Search Patient Service Centers
 */

export function useSearchPatientServiceCentersV0LabsPatientServiceCentersGet<TData = Awaited<ReturnType<typeof searchPatientServiceCentersV0LabsPatientServiceCentersGet>>, TError = HTTPValidationError>(
 params: SearchPatientServiceCentersV0LabsPatientServiceCentersGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchPatientServiceCentersV0LabsPatientServiceCentersGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getSearchPatientServiceCentersV0LabsPatientServiceCentersGetQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Get Lab Orders
 */
export const getLabOrdersV0LabsOrdersGet = (
    params?: GetLabOrdersV0LabsOrdersGetParams,
 signal?: AbortSignal
) => {
      
      
      return customCatchBackendFetcher<LabOrdersListResponse>(
      {url: `/v0/labs/orders`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetLabOrdersV0LabsOrdersGetQueryKey = (params?: GetLabOrdersV0LabsOrdersGetParams,) => {
    return [`/v0/labs/orders`, ...(params ? [params]: [])] as const;
    }

    
export const getGetLabOrdersV0LabsOrdersGetQueryOptions = <TData = Awaited<ReturnType<typeof getLabOrdersV0LabsOrdersGet>>, TError = HTTPValidationError>(params?: GetLabOrdersV0LabsOrdersGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLabOrdersV0LabsOrdersGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLabOrdersV0LabsOrdersGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLabOrdersV0LabsOrdersGet>>> = ({ signal }) => getLabOrdersV0LabsOrdersGet(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLabOrdersV0LabsOrdersGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetLabOrdersV0LabsOrdersGetQueryResult = NonNullable<Awaited<ReturnType<typeof getLabOrdersV0LabsOrdersGet>>>
export type GetLabOrdersV0LabsOrdersGetQueryError = HTTPValidationError


export function useGetLabOrdersV0LabsOrdersGet<TData = Awaited<ReturnType<typeof getLabOrdersV0LabsOrdersGet>>, TError = HTTPValidationError>(
 params: undefined |  GetLabOrdersV0LabsOrdersGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLabOrdersV0LabsOrdersGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLabOrdersV0LabsOrdersGet>>,
          TError,
          Awaited<ReturnType<typeof getLabOrdersV0LabsOrdersGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLabOrdersV0LabsOrdersGet<TData = Awaited<ReturnType<typeof getLabOrdersV0LabsOrdersGet>>, TError = HTTPValidationError>(
 params?: GetLabOrdersV0LabsOrdersGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLabOrdersV0LabsOrdersGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLabOrdersV0LabsOrdersGet>>,
          TError,
          Awaited<ReturnType<typeof getLabOrdersV0LabsOrdersGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLabOrdersV0LabsOrdersGet<TData = Awaited<ReturnType<typeof getLabOrdersV0LabsOrdersGet>>, TError = HTTPValidationError>(
 params?: GetLabOrdersV0LabsOrdersGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLabOrdersV0LabsOrdersGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get Lab Orders
 */

export function useGetLabOrdersV0LabsOrdersGet<TData = Awaited<ReturnType<typeof getLabOrdersV0LabsOrdersGet>>, TError = HTTPValidationError>(
 params?: GetLabOrdersV0LabsOrdersGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLabOrdersV0LabsOrdersGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetLabOrdersV0LabsOrdersGetQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Create Lab Order
 */
export const createLabOrderV0LabsOrdersPost = (
    labOrderRequest: LabOrderRequest,
 signal?: AbortSignal
) => {
      
      
      return customCatchBackendFetcher<LabOrderResponseV0>(
      {url: `/v0/labs/orders`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: labOrderRequest, signal
    },
      );
    }
  


export const getCreateLabOrderV0LabsOrdersPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLabOrderV0LabsOrdersPost>>, TError,{data: LabOrderRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createLabOrderV0LabsOrdersPost>>, TError,{data: LabOrderRequest}, TContext> => {

const mutationKey = ['createLabOrderV0LabsOrdersPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createLabOrderV0LabsOrdersPost>>, {data: LabOrderRequest}> = (props) => {
          const {data} = props ?? {};

          return  createLabOrderV0LabsOrdersPost(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateLabOrderV0LabsOrdersPostMutationResult = NonNullable<Awaited<ReturnType<typeof createLabOrderV0LabsOrdersPost>>>
    export type CreateLabOrderV0LabsOrdersPostMutationBody = LabOrderRequest
    export type CreateLabOrderV0LabsOrdersPostMutationError = HTTPValidationError

    /**
 * @summary Create Lab Order
 */
export const useCreateLabOrderV0LabsOrdersPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLabOrderV0LabsOrdersPost>>, TError,{data: LabOrderRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createLabOrderV0LabsOrdersPost>>,
        TError,
        {data: LabOrderRequest},
        TContext
      > => {

      const mutationOptions = getCreateLabOrderV0LabsOrdersPostMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * @summary Get Lab Order
 */
export const getLabOrderV0LabsOrdersJunctionOrderIdGet = (
    junctionOrderId: string,
 signal?: AbortSignal
) => {
      
      
      return customCatchBackendFetcher<LabOrderDetail>(
      {url: `/v0/labs/orders/${junctionOrderId}`, method: 'GET', signal
    },
      );
    }
  

export const getGetLabOrderV0LabsOrdersJunctionOrderIdGetQueryKey = (junctionOrderId?: string,) => {
    return [`/v0/labs/orders/${junctionOrderId}`] as const;
    }

    
export const getGetLabOrderV0LabsOrdersJunctionOrderIdGetQueryOptions = <TData = Awaited<ReturnType<typeof getLabOrderV0LabsOrdersJunctionOrderIdGet>>, TError = HTTPValidationError>(junctionOrderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLabOrderV0LabsOrdersJunctionOrderIdGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLabOrderV0LabsOrdersJunctionOrderIdGetQueryKey(junctionOrderId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLabOrderV0LabsOrdersJunctionOrderIdGet>>> = ({ signal }) => getLabOrderV0LabsOrdersJunctionOrderIdGet(junctionOrderId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(junctionOrderId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLabOrderV0LabsOrdersJunctionOrderIdGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetLabOrderV0LabsOrdersJunctionOrderIdGetQueryResult = NonNullable<Awaited<ReturnType<typeof getLabOrderV0LabsOrdersJunctionOrderIdGet>>>
export type GetLabOrderV0LabsOrdersJunctionOrderIdGetQueryError = HTTPValidationError


export function useGetLabOrderV0LabsOrdersJunctionOrderIdGet<TData = Awaited<ReturnType<typeof getLabOrderV0LabsOrdersJunctionOrderIdGet>>, TError = HTTPValidationError>(
 junctionOrderId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLabOrderV0LabsOrdersJunctionOrderIdGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLabOrderV0LabsOrdersJunctionOrderIdGet>>,
          TError,
          Awaited<ReturnType<typeof getLabOrderV0LabsOrdersJunctionOrderIdGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLabOrderV0LabsOrdersJunctionOrderIdGet<TData = Awaited<ReturnType<typeof getLabOrderV0LabsOrdersJunctionOrderIdGet>>, TError = HTTPValidationError>(
 junctionOrderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLabOrderV0LabsOrdersJunctionOrderIdGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLabOrderV0LabsOrdersJunctionOrderIdGet>>,
          TError,
          Awaited<ReturnType<typeof getLabOrderV0LabsOrdersJunctionOrderIdGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLabOrderV0LabsOrdersJunctionOrderIdGet<TData = Awaited<ReturnType<typeof getLabOrderV0LabsOrdersJunctionOrderIdGet>>, TError = HTTPValidationError>(
 junctionOrderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLabOrderV0LabsOrdersJunctionOrderIdGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get Lab Order
 */

export function useGetLabOrderV0LabsOrdersJunctionOrderIdGet<TData = Awaited<ReturnType<typeof getLabOrderV0LabsOrdersJunctionOrderIdGet>>, TError = HTTPValidationError>(
 junctionOrderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLabOrderV0LabsOrdersJunctionOrderIdGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetLabOrderV0LabsOrdersJunctionOrderIdGetQueryOptions(junctionOrderId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



